module.exports = __webpack_public_path__ + "img/pic_location_Thai_bangkok.83fb56ba.png";